<template>
  <div>
    <!-- <header>
      <Header msg="Header" />
      <SettingsHeader msg="SettingsHeader" />
    </header> -->
    <main>
      <div class="qcmoney">
        <div>目前累積</div>
        <div class="point flex_center">
          <i class="icon-point">$</i>{{ this.qcMoney }}
        </div>
        <!-- <time>使用期限：2021-09-03 23:59</time> -->
      </div>

      <!-- 快金分頁 -->
      <nav class="tabs qcmoney">
        <div class="container">
          <a
            href="javascript:"
            v-if="exchangeCampaigns.length"
            v-on:click="selected = 'exchange'"
            :class="[selected === 'exchange' ? 'current' : '']"
            >兌換快金</a
          >
          <a
            href="javascript:"
            v-on:click="selected = 'add'"
            :class="[selected === 'add' ? 'current' : '']"
            >兌換記錄</a
          >
          <a
            href="javascript:"
            v-on:click="selected = 'redeem'"
            :class="[selected === 'redeem' ? 'current' : '']"
            >使用記錄</a
          >
        </div>
      </nav>

      <!-- 兌換快金 Start -->
      <div
        v-if="selected === 'exchange' && exchangeCampaigns.length"
        class="exchange container"
      >
        <h5>您目前有</h5>
        {{ this.exchangeCampaigns[0].title }}：{{
          this.exchangeCampaigns[0].user
            ? this.exchangeCampaigns[0].user.point_total
            : 0
        }}
        <div v-if="noAvblOptions" class="point lion flex_center disabled">
          <i class="icon-lion"></i>
          <input
            type="text"
            :value="
              exchangeCampaigns[0].user
                ? exchangeCampaigns[0].user.point_total
                : 0
            "
            disabled
          />
        </div>
        <div
          v-else-if="
            exchangeCampaigns[0].formConf &&
              exchangeCampaigns[0].formConf.data &&
              exchangeCampaigns[0].formConf.type === 'select'
          "
          class="point lion flex_center"
        >
          <i class="icon-lion"></i>
          <select v-model="vendorPoints" id="lion_point">
            <option
              v-for="o in exchangeCampaigns[0].formConf.data.values"
              v-if="
                exchangeCampaigns[0].user &&
                  exchangeCampaigns[0].user.point_total >= o.value
              "
              v-bind:value="o.value"
              >{{ o.label }}</option
            >
          </select>
        </div>

        <p><br /></p>
        <h5 v-if="noAvblOptions">
          {{ exchangeCampaigns[0].description }}<br />
        </h5>
        <h5 v-else>可兌換<br /><i class="icon-arrow-change"></i></h5>

        <p><br /></p>
        {{ !noAvblOptions ? "快金" : "" }}
        <div v-if="!noAvblOptions" class="point flex_center">
          <i class="icon-point">$</i>
          <span id="qcmoney">{{
            formulaEval({ vendorPoints: vendorPoints })
          }}</span>
        </div>
        <a v-if="!noAvblOptions" class="btn" href="#alert" rel="modal:open"
          >我要兌換</a
        >
      </div>

      <!-- 商業獅點數大於20點可兌換 -->
      <div v-if="selected === 'exchange'" id="alert" class="modal notify">
        <ul>
          <li>將商業獅點數轉換成快金後，將無法返還點數，確定要兌換嗎？</li>
          <li>
            <a class="btn cancel" href="#" rel="modal:close">取消</a>
            
            <a
              class="btn submit"
              href="#success"
              rel="modal:open"
              v-on:click="changePointsToQCMoney(exchangeCampaigns[0]); showSuccess = false;"
              >確定</a
            >
            <!-- <a
              class="btn submit"
              href="#"
              rel="modal:close"
              v-on:click="changePointsToQCMoney(exchangeCampaigns[0])"
              >確定</a
            > -->
          </li>
        </ul>
      </div>

      <div id="success" class="modal notify">
        <h2>{{ showSuccess ? '兌換成功' : '兌換進行中'}}</h2>
        <ul>
          <li class="flex_center">商業獅點數<i class="icon-lion"></i> {{vendorPoints}}</li>
          <li v-if="showSuccess" class="flex_center">已兌換快金<i class="icon-point">$</i> {{formulaEval({ vendorPoints: vendorPoints })}}</li>
          <li>
            <a class="btn cancel" href="#" rel="modal:close" v-on:click="showSuccess = false">關閉</a>
          </li>
        </ul>
      </div>

      <!-- 商業獅點數小於20點無法兌換 -->
      <!-- <div v-if="selected === 'exchange'" class="exchange container">
        <h5>您目前有</h5>
        商業獅點數：19
        <div class="point lion flex_center disabled">
          <i class="icon-lion"></i>
          <input type="text" value="19" disabled />
        </div>

        <p><br /></p>
        <h5>每20點可兌換<br /><i class="icon-arrow-change"></i></h5>
        <p><br /></p>

        快金
        <div class="point flex_center">
          <i class="icon-point">$</i>
          <span id="qcmoney">100</span>
        </div>
      </div> -->
      <!-- 兌換快金End -->

      <!-- 兌換紀錄 -->
      <ul v-if="selected === 'add'" class="log_list">
        <li v-for="(t, index) in transactions['add']" class="flex_center">
          <div class="item_from">
            {{ t.log }}
            <time>{{ t.createdTime }}</time>
          </div>
          <div class="point"><i class="icon-point">$</i>+{{ t.money }}</div>
        </li>
      </ul>

      <ul v-if="selected === 'redeem'" class="log_list use">
        <li v-for="(t, index) in transactions['redeem']" class="flex_center">
          <div class="item_from">
            {{ t.log }}
            <time>{{ t.createdTime }}</time>
          </div>
          <div :class="['point', t.money >= 0 ? '' : '']">
            <i class="icon-point">$</i>{{ t.money >= 0 ? "+" : ""
            }}{{ t.money }}
          </div>
        </li>
      </ul>
    </main>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
// import Header from "@/components/Header.vue";
// import SettingsHeader from "@/components/SettingsHeader.vue";
import { Base64 } from "js-base64";
import { authService } from "@/services/auth";

import Header from "@/components/Header.vue";
import SettingsHeader from "@/components/SettingsHeader.vue";
import apis from "@/services/apis";
import { myEval, myParse } from "@/services/iiotformulas";
import moment from "moment";

export default {
  name: "QCMoney",
  data() {
    return {
      selected: "add",
      isMember: false,
      qcMoney: 0,
      transactions: {
        add: [],
        redeem: [],
      },
      exchangeCampaigns: [],
      vendorPoints: 0,
      noAvblOptions: false,
      showSuccess: false
    };
  },
  // components: {
  //   SettingsHeader,
  //   Header,
  // },
  computed: {
    // userId() {
    //   return localStorage.getItem("lineUserId");
    // },
    userId() {
      let userId = localStorage.getItem("lineUserId");
      let userProfile = localStorage.getItem("lineUserProfile");
      let self = this;

      if (userProfile) {
        let userProfileObj = JSON.parse(Base64.decode(userProfile));
        // console.log('debug the user profile obj ' + JSON.stringify(userProfileObj));
        // console.log('vs ' + GLOBAL_ENV_LIFFID);
        if (
          !userProfileObj.liffApp ||
          userProfileObj.liffApp !== GLOBAL_ENV_LIFFID
        ) {
          userId = userProfile = null;
        }
      }
      return userId;
      // return localStorage.getItem("lineUserId");
    },
    uuid() {
      let uuid = localStorage.getItem("qcsso:uuid");
      console.log("compute the uuid " + uuid);
      let userProfile = localStorage.getItem("lineUserProfile");
      let self = this;

      // if (userProfile) {
      //   let userProfileObj = JSON.parse(Base64.decode(userProfile));
      //   // console.log('debug the user profile obj ' + JSON.stringify(userProfileObj));
      //   // console.log('vs ' + GLOBAL_ENV_LIFFID);
      //   if (
      //     !userProfileObj.liffApp ||
      //     userProfileObj.liffApp !== GLOBAL_ENV_LIFFID
      //   ) {
      //     uuid = userProfile = null;
      //   }
      // }
      return uuid;
      // return localStorage.getItem("lineUserId");
    },
    userProfile() {
      try {
        let obj = JSON.parse(
          Base64.decode(localStorage.getItem("lineUserProfile"))
        );
        return obj;
      } catch (e) {
        return {};
      }
    },
  },
  methods: {
    isQCMoneyMember() {
      // 如果是快金會員，要顯示快金頁面
      // 查看user資訊
      console.log("phone ", this.userProfile);
      if (this.userProfile && this.userProfile.phone) {
        console.log("go qcmoney");
        apis
          .checkQCMoney(this.userProfile.phone)
          .then((response) => {
            console.log("the qcmoney response ", response);
            if (response && response.isMember) {
              this.isMember = true;
              this.qcMoney = response.qcMoney || 0;
            }

            console.log("qcmoney", response);
          })
          .catch((e) => {
            console.log("qcmoney failed " + e.stack);
          });
      }
    },
    getQCMoneyTransactions() {
      let self = this;
      if (this.userProfile && this.userProfile.phone) {
        apis
          .getQCMoneyTransactions(this.userProfile.phone)
          .then((response) => {
            console.log("the qcmoney response ", response);
            if (response && response.isMember) {
              this.isMember = true;
              this.qcMoney = response.qcMoney || 0;
            }
            self.transactions = {
              "add": [],
              "redeem": []
            }


            for (let i = 0; i < response.length; ++i) {
              if (response[i].type === "ADD") {
                response[i].createdTime = moment
                  .unix(response[i].createdTs)
                  .format("YYYY-MM-DD HH:mm:ss");
                self.transactions["add"].push(response[i]);
              } else {
                response[i].createdTime = moment
                  .unix(response[i].createdTs)
                  .format("YYYY-MM-DD HH:mm:ss");
                self.transactions["redeem"].push(response[i]);
              }
            }

            console.log("transactions", response);
            console.log("split " + JSON.stringify(self.transactions));
          })
          .catch((e) => {
            console.log("qcmoney failed " + e.stack);
          });
      }
    },
    getQCMoneyExchangesByShopId() {
      let self = this;
      if (this.$router.currentRoute.query.s) {
        console.log("get campaign shop id");
        apis
          .getQCMoneyExchangesByShopId(
            this.$router.currentRoute.query.s,
            this.userProfile.phone
          )
          .then((response) => {
            console.log("the qcmoney exchange response ", response);
            // 理論上應該可以有多家兌換管道，但現在先只處理一間（介面的關係）
            self.exchangeCampaigns = response;
            // self.exchangeCampaigns[0].user.point_total = 1000; // debug
            if (
              self.exchangeCampaigns[0].formConf.data.values &&
              self.exchangeCampaigns[0].user &&
              self.exchangeCampaigns[0].formConf.data.values[0]
            ) {
              // 都用第一個做為預設職

              if (
                self.exchangeCampaigns[0].formConf.data.values[0].value <=
                self.exchangeCampaigns[0].user.point_total
              ) {
                self.vendorPoints =
                  self.exchangeCampaigns[0].formConf.data.values[0].value;
              } else {
                // 點數太少了
                self.noAvblOptions = true;
              }
            }
            console.log("exchange ", self.exchangeCampaigns);
            console.log("noAvblOptions " + self.noAvblOptions);
          })
          .catch((e) => {
            console.log("exchange failed ", e);
          });
      }
    },
    formulaEval(variables, formula) {
      return myEval(variables, this.exchangeCampaigns[0].rateFormula);
    },
    changePointsToQCMoney(exchangeConf) {
      
      let self = this;
     
      if (
        this.$router.currentRoute.query.s &&
        this.userProfile &&
        this.userProfile.phone
      ) {
        apis
          .changePointsToQCMoney(this.$router.currentRoute.query.s, {
            vendor: exchangeConf.vendor,
            phone: self.userProfile.phone,
            vendorPoints: self.vendorPoints,
          })
          .then((response) => {
            this.showSuccess = true;
            // 重整頁面
            self.isQCMoneyMember();
            self.getQCMoneyTransactions();
            self.getQCMoneyExchangesByShopId();
          })
          .catch((e) => {
            alert("兌換失敗 " + e.stack);
          });
      }
    },
  },
  mounted() {
    let self = this;
    this.isQCMoneyMember();
    this.getQCMoneyTransactions();
    this.getQCMoneyExchangesByShopId();
    // console.log(this.userProfile);
    // console.log('so what is our picture? ' + this.picture);

    // apis.getUserAddresses(this.userId)
    // .then(addresses => {
    //   console.log('the addresses ' + JSON.stringify(addresses));
    // });
  },
  props: ["type"],
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
div#alert {
  /* 吃不到global的只好補一下 */
  padding-top: 40px;
  text-align: center;
}
</style>
